import "swiper/css";

import { SectionTitle } from "../../ui/SectionTitle/SectionTitle";
import { StepButton } from "../../ui/StepButton/StepButton";
import { SimpleCard } from "./SimpleCard/SimpleCard";
import { addStylesTitle } from "./addStyles";

import {
  SwiperSlideStyled,
  SwiperStyled,
  WrapperButtons,
  WrapperRoot,
} from "./Slider.styled";

export const Slider = ({
  buttons,
  title,
  settings,
  slideFullWidth,
  addStyles,
  type,
  blog = false,
  facts = [],
  mainpage,
  getshorter,
}) => {
  return (
    <>
      <SwiperStyled
        addStyles={addStyles?.swiper}
        {...settings}
        navigation={{ nextEl: ".arrow-right", prevEl: ".arrow-left" }}
      >
        <WrapperRoot>
          {title && <SectionTitle title={title} addStyles={addStylesTitle} />}
          {buttons && (
            <WrapperButtons>
              <StepButton className="arrow-left" direction="left" />
              <StepButton className="arrow-right" direction="right" />
            </WrapperButtons>
          )}
        </WrapperRoot>
        {facts.length > 0 &&
          facts.map((item, index) => (
            <SwiperSlideStyled key={item.id} slideFullWidth={slideFullWidth}>
              <SimpleCard
                {...item}
                index={index}
                addStyles={addStyles?.cardStyles}
                type={type}
                fullwidth={+true}
                fixheight={+true}
                blog={blog}
                description={item.description}
                link={item.slug}
                mainpage={mainpage}
                getshorter={getshorter}
              />
            </SwiperSlideStyled>
          ))}
      </SwiperStyled>
    </>
  );
};
